import React from 'react'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'

const PasswordChangeTab = () => {
	const { t } = useTranslation()
	const handleSubmit = e => {
		e.preventDefault()
		Swal.fire({
			title: t('settingsPage.password.messages.changedTitle'),
			text: t('settingsPage.password.messages.changedText'),
			icon: 'success',
			confirmButtonColor: '#3085d6',
		})
	}

	return (
		<div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
			<div>
				<h2 className="text-base/7 font-semibold text-gray-900">{t('settingsPage.password.title')}</h2>
				<p className="mt-1 text-sm/6 text-gray-500">{t('settingsPage.password.subtitle')}</p>
			</div>
			<div className="md:col-span-2">
				<form className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6" onSubmit={handleSubmit}>

					<div className="col-span-full">
						<label htmlFor="current-password" className="block text-sm/6 font-medium text-gray-900">
							{t('settingsPage.password.fields.currentPassword')}
						</label>
						<div className="mt-2">
							<input
								id="current-password"
								name="current_password"
								type="password"
								autoComplete="current-password"
								required
								className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
							/>
						</div>
					</div>

					<div className="col-span-full">
						<label htmlFor="new-password" className="block text-sm/6 font-medium text-gray-900">
							{t('settingsPage.password.fields.newPassword')}
						</label>
						<div className="mt-2">
							<input
								id="new-password"
								name="new_password"
								type="password"
								autoComplete="new-password"
								required
								className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
							/>
						</div>
					</div>

					<div className="col-span-full">
						<label htmlFor="confirm-password" className="block text-sm/6 font-medium text-gray-900">
							{t('settingsPage.password.fields.confirmPassword')}
						</label>
						<div className="mt-2">
							<input
								id="confirm-password"
								name="confirm_password"
								type="password"
								autoComplete="new-password"
								required
								className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
							/>
						</div>
					<div className="col-span-full mt-8 flex">
						<button type="submit" className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
							{t('settingsPage.password.actions.save')}
						</button>
					</div>

					</div>
				</form>
			</div>
		</div>
	)
}

export default PasswordChangeTab
